module.exports = __webpack_public_path__ + "img/6_56.0e7f4ad5.png";